import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input,Card, Button,Collapse,Tooltip,Spin,Switch,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined,DownloadOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import { LedgerJournalInfoAlert } from '../journalReportUtils';
import {
  BalanceSheetCategoryTable,
  balanceSheetAccountKey,
  getBalanceSheetSectionStateKey,
  mergeBreakdownIntoSection,
  parseBalanceSheetSections,
} from '../balanceSheetReportUtils';
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import '../tablestyle.css'; // Create this CSS file for custom styles
import ReactExport from "@ibrahimrahmani/react-export-excel";

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { TabPane } = Tabs;


const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


var token= ''
var sacco= ''
var bizuserid= ''

class ReportToPrint extends React.Component {

    state = {
    ...initialReportEmailState(),
      companyprofile:{}
    };
  
    componentDidMount(){
      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }


      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })
  
    }


    calculateTotalBalance=(list)=>{
      var total =0
      list.map((item)=>{
        total+=Number(item.balance)
      })
      return total.toFixed(2);
    }


calculateTotalDebit=(list)=>{
  var total =0
  list.map((item)=>{
    total+=Number(item.debit)
  })
  return total.toFixed(2);
}


calculateTotalCredit=(list)=>{
  var total =0
  list.map((item)=>{
    total+=Number(item.credit)
  })
  return total.toFixed(2);
}

    

    render() {
      return (
        <div style={{padding:20}} className="balance-sheet-print-root">
           <Row className="balance-sheet-print-header"> 
                <Col xs="12" md="2" lg="2" className="balance-sheet-print-logo-col">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="12" md="6" lg="6" className="balance-sheet-print-info-col">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h5>{this.state.companyprofile.companydealership}</h5>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>
                  </Col>

           </Row>

           <h2 className="balance-sheet-print-title" style={{justifyContent:'center',display:'flex',alignSelf:'center'}}>{"BALANCE SHEET REPORT FROM "+this.props.dateone+" TO "+this.props.datetwo }</h2>
            <br></br>
            <h4 style={{justifyContent:'center',display:'flex',alignSelf:'center',color:'blue'}}>ASSETS</h4>
         
            {
                          this.props.balancesheet_report_assets.map((catgry)=>{
                            return (
                              <div>
                                <h3>{catgry.chatofaccounts_subcategory}</h3>
            
             {
                                  catgry.report.length>0?
                                  <div>
                                    <reactstrp.Table bordered className="balance-sheet-equal-cols">
                                      <thead>
                                        <tr>
                                          <th>Account</th>
                                          {this.props.view_opening_balance?<th>Opening Balance</th>:null}
                                          <th>Debit</th>
                                          <th>Credit</th>
            
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {
                                          catgry.report.map((item)=>(
                                            <Tooltip title="Click to view details" placement="top">
                                            <tr onClick={()=>{
                                              this.setState({selected_record:item})
                                              this.setState({ledeger_details_model_visible:true})
                                              }}>                              
                                                <td>{item.account}</td>
                                              {this.props.view_opening_balance? <td className="align-right">{<CurrencyFormat value={item.total_inst_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            
                                            <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                                            <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
            
                                            </tr>
                                            </Tooltip>
                                          ))
                                        }
            
                                        <tr>
                                        <td>Total</td>
                                        {this.props.view_opening_balance?<td></td>:null}
                                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalDebit(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</td>
                                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalCredit(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</td>
                                        </tr>
            
                                        </tbody>
                                       </reactstrp.Table> 
                                  </div>
                                  :
                                  null
                                }
                              </div>
                            );
            
                          })
                        }
            
                       <reactstrp.Table bordered className="balance-sheet-equal-cols">
                          <thead>
                            <tr>
                              <th><h1 style={{color:'blue'}}>TOTAL ASSETS</h1></th>
                              {this.props.view_opening_balance?<th></th>:null}
                              <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={this.props.AllTotals.total_debits_asset} displayType={'text'} thousandSeparator={true}/></h1></th>
                              <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={this.props.AllTotals.total_credits_asset} displayType={'text'} thousandSeparator={true}/></h1></th>
            
                            </tr>
                          </thead>
                      </reactstrp.Table>
            
            
                      {/**
                       * 
                       * FINANCED BY EQUITY AND LIABILITIES
                       * 
                       * 
                       * 
                       * 
                       */}
            
            
                      <h4 style={{justifyContent:'center',display:'flex',alignSelf:'center',color:'blue'}}>FINANCED BY</h4>
                      <h5 style={{justifyContent:'center',display:'flex',alignSelf:'center'}}>Equity</h5>
                      {
                          this.props.balancesheet_report_equity.map((catgry)=>{
                            return (
                              <div>
                                <h3>{catgry.chatofaccounts_subcategory}</h3>
            
             {
                                  catgry.report.length>0?
                                  <div>
                                    <reactstrp.Table bordered className="balance-sheet-equal-cols">
                                      <thead>
                                        <tr>
                                          <th>Account</th>
                                         {this.props.view_opening_balance? <th>Opening Balance</th>:null}
                                          <th>Debit</th>
                                          <th>Credit</th>
            
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {
                                          catgry.report.map((item)=>(
                                            <Tooltip title="Click to view details" placement="top">
                                            <tr onClick={()=>{
                                              this.setState({selected_record:item})
                                              this.setState({ledeger_details_model_visible:true})
                                              }}>                              
                                                <td>{item.account}</td>
                                              {this.props.view_opening_balance? <td className="align-right">{<CurrencyFormat value={item.total_inst_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            
                                            <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                                            <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
            
                                            </tr>
                                            </Tooltip>
                                          ))
                                        }
            
                                        <tr>
                                        <td>Total</td>
                                       {this.props.view_opening_balance? <td></td>:null}
                                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalDebit(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</td>
                                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalCredit(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</td>
                                        </tr>
            
                                        </tbody>
                                       </reactstrp.Table> 
                                  </div>
                                  :
                                  null
                                }
                              </div>
                            );
            
                          })
                        }
                     <reactstrp.Table bordered className="balance-sheet-equal-cols">
                          <thead>
                            <tr>
                              <th><h2 style={{color:'green'}}>TOTAL EQUITY</h2></th>
                             {this.props.view_opening_balance? <th></th>:null}
                              <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.props.AllTotals.total_debits_equity} displayType={'text'} thousandSeparator={true}/></h2></th>
                              <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.props.AllTotals.total_credits_equity} displayType={'text'} thousandSeparator={true}/></h2></th>
            
                            </tr>
                          </thead>
                      </reactstrp.Table>
            
                      <h5 style={{justifyContent:'center',display:'flex',alignSelf:'center'}}>Liability</h5>
                      {
                          this.props.balancesheet_report_liability.map((catgry)=>{
                            return (
                              <div>
                                <h3>{catgry.chatofaccounts_subcategory}</h3>
            
             {
                                  catgry.report.length>0?
                                  <div>
                                    <reactstrp.Table bordered className="balance-sheet-equal-cols">
                                      <thead>
                                        <tr>
                                          <th>Account</th>
                                         {this.props.view_opening_balance? <th>Opening Balance</th>:null}
                                          <th>Debit</th>
                                          <th>Credit</th>
            
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {
                                          catgry.report.map((item)=>(
                                            <Tooltip title="Click to view details" placement="top">
                                            <tr onClick={()=>{
                                              this.setState({selected_record:item})
                                              this.setState({ledeger_details_model_visible:true})
                                              }}>                              
                                                <td>{item.account}</td>
                                              {this.props.view_opening_balance? <td className="align-right">{<CurrencyFormat value={item.total_inst_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
            
                                            <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                                            <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
            
                                            </tr>
                                            </Tooltip>
                                          ))
                                        }
            
                                        <tr>
                                        <td>Total</td>
                                        {this.props.view_opening_balance?<td></td>:null}
                                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalDebit(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</td>
                                        <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={this.calculateTotalCredit(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</td>
                                        </tr>
            
                                        </tbody>
                                       </reactstrp.Table> 
                                  </div>
                                  :
                                  null
                                }
                              </div>
                            );
            
                          })
                        }
                     <reactstrp.Table bordered className="balance-sheet-equal-cols">
                          <thead>
                            <tr>
                              <th><h2 style={{color:'green'}}>TOTAL LIABILITY</h2></th>
                             {this.props.view_opening_balance? <th></th>:null}
                              <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.props.AllTotals.total_debits_liability} displayType={'text'} thousandSeparator={true}/></h2></th>
                              <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.props.AllTotals.total_credits_liability} displayType={'text'} thousandSeparator={true}/></h2></th>
            
                            </tr>
                          </thead>
                      </reactstrp.Table>
                      <br></br>
            
            
                      <reactstrp.Table bordered className="balance-sheet-equal-cols">
                          <thead>
                            <tr>
                              <th><h1 style={{color:'blue'}}>TOTAL EQUITY & LIABILITY</h1></th>
                             {this.props.view_opening_balance? <th></th>:null}
                              <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={(this.props.AllTotals.total_debits_liability+this.props.AllTotals.total_debits_equity).toFixed(2)} displayType={'text'} thousandSeparator={true}/></h1></th>
                              <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={(this.props.AllTotals.total_credits_liability+this.props.AllTotals.total_credits_equity).toFixed(2)} displayType={'text'} thousandSeparator={true}/></h1></th>
                            </tr>
                          </thead>
                      </reactstrp.Table>
            
        </div>
      );
    }
  }


class BalanceSheetDateRangeView extends React.Component {

  state = {
   ...initialReportEmailState(),
   datarequested:true,
   dateone:moment().format(dateFormat).toString(),
   datetwo:moment().format(dateFormat).toString(),
   companyprofile: {},

   balancesheet_report_assets:[],

   balancesheet_report_liability:[],
   balancesheet_report_equity:[],
   AllTotals:{},

   general_report:[],

    //view opening balance controller
   view_opening_balance:false,

   expandedAccountKey: null,
   breakdownLoadingKey: null,
   reportBasis: '',

  };

  loadBalanceSheetReport = () => {
    const form_data = new FormData();
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    form_data.append('sacco', sacco);

    submitReportWithEmail({
      reportKey: REPORT_KEYS.BALANCE_SHEET_DATERANGE,
      params: { dateone: this.state.dateone, datetwo: this.state.datetwo, sacco },
      emailReport: this.state.email_report,
      receivingEmail: this.state.receiving_email,
      endpoint: serverconfig.backendserverurl + '/customqueries/get_balancesheet_daterange',
      formData: form_data,
      setLoading: (v) => this.setState({
        datarequested: v,
        ...(v ? { expandedAccountKey: null, reportBasis: '' } : {}),
      }),
      onSuccess: (res) => {
        this.setState({
          balancesheet_report_assets: parseBalanceSheetSections(JSON.parse(res.data.balancesheet_report_assets)),
          balancesheet_report_liability: parseBalanceSheetSections(JSON.parse(res.data.balancesheet_report_liability)),
          balancesheet_report_equity: parseBalanceSheetSections(JSON.parse(res.data.balancesheet_report_equity)),
          general_report: JSON.parse(res.data.general_report),
          AllTotals: res.data.AllTotals,
        });
      },
      useInlineEmail: true,
    });
  };

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {
      this.setState((prev) => ({
        companyprofile: res.data,
        receiving_email: prev.receiving_email || res.data.company_email || '',
      }));
    });

    this.loadBalanceSheetReport();
  
}


calculateTotalBalance=(list)=>{
  var total =0
  list.map((item)=>{
    total+=Number(item.balance)
  })
  return total.toFixed(2);
}


calculateTotalDebit=(list)=>{
  var total =0
  list.map((item)=>{
    total+=Number(item.debit)
  })
  return total.toFixed(2);
}


calculateTotalCredit=(list)=>{
  var total =0
  list.map((item)=>{
    total+=Number(item.credit)
  })
  return total.toFixed(2);
}

loadAccountBreakdown = (item, sectionKey) => {
  if (!item || item.breakdownLoaded) {
    return;
  }
  const rowKey = balanceSheetAccountKey(sectionKey, item);
  this.setState({ breakdownLoadingKey: rowKey });
  const form_data = new FormData();
  form_data.append('sacco', sacco);
  form_data.append('account', item.account);
  form_data.append('dateone', this.state.dateone);
  form_data.append('datetwo', this.state.datetwo);
  axios.post(
    serverconfig.backendserverurl + '/customqueries/getTrialBalanceBreakdown_daterange',
    form_data,
    { timeout: 120000 }
  )
    .then((res) => {
      const breakdown = res.data.breakdown || [];
      const breakdownError = res.data.error_detail || null;
      const breakdownSummary = {
        trial_balance_debit: res.data.trial_balance_debit,
        trial_balance_credit: res.data.trial_balance_credit,
        total_debit: res.data.total_debit,
        total_credit: res.data.total_credit,
      };
      const stateKey = getBalanceSheetSectionStateKey(sectionKey);
      this.setState({
        [stateKey]: mergeBreakdownIntoSection(
          this.state[stateKey],
          sectionKey,
          rowKey,
          breakdown,
          breakdownSummary,
          breakdownError
        ),
        reportBasis: res.data.report_basis || '',
        breakdownLoadingKey: null,
      });
    })
    .catch((err) => {
      console.log(err);
      message.error('Failed to load GL breakdown for this account');
      this.setState({ breakdownLoadingKey: null });
    });
};

toggleAccountBreakdown = (item, sectionKey) => {
  const rowKey = balanceSheetAccountKey(sectionKey, item);
  if (this.state.expandedAccountKey === rowKey) {
    this.setState({ expandedAccountKey: null });
    return;
  }
  this.setState({ expandedAccountKey: rowKey });
  if (!item.breakdownLoaded) {
    this.loadAccountBreakdown(item, sectionKey);
  }
};

renderBalanceSheetSection = (sections, sectionKey) => (
  sections.map((catgry) => (
    <div key={`${sectionKey}-${catgry.chatofaccounts_subcategory}`}>
      <h3>{catgry.chatofaccounts_subcategory}</h3>
      <BalanceSheetCategoryTable
        catgry={catgry}
        sectionKey={sectionKey}
        viewOpeningBalance={this.state.view_opening_balance}
        expandedAccountKey={this.state.expandedAccountKey}
        breakdownLoadingKey={this.state.breakdownLoadingKey}
        reportBasis={this.state.reportBasis}
        onToggleBreakdown={this.toggleAccountBreakdown}
        calculateTotalDebit={this.calculateTotalDebit}
        calculateTotalCredit={this.calculateTotalCredit}
      />
    </div>
  ))
);




  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {
    
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div className="balance-sheet-page">
          <LedgerJournalInfoAlert />
         <div style={{display: "none"}}>
             &nbsp;&nbsp;
            <ReportToPrint
            dateone={this.state.dateone}
            datetwo={this.state.datetwo}

            balancesheet_report_assets={this.state.balancesheet_report_assets}
            balancesheet_report_equity={this.state.balancesheet_report_equity}
            balancesheet_report_liability={this.state.balancesheet_report_liability}
            AllTotals={this.state.AllTotals}
            ref={el => (this.componentRef = el)} 
            
            view_opening_balance={this.state.view_opening_balance}

            /> 

          </div>

          <div className="balance-sheet-page-shell">
              
          <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header={"BALANCE SHEET REPORT FROM "+this.state.dateone+" TO "+this.state.datetwo} key="1">
 
            <div className="balance-sheet-toolbar">
            <div className="balance-sheet-toolbar-actions">
            {!this.state.email_report ? (
            <>
            <ReactToPrint
            trigger={() => 
            <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
            Print
            </Button>
            }
            content={() => this.componentRef}
            />

            <ExcelFile filename={"Pisacco - BalanceSheet from "+this.state.dateone +" to "+this.state.datetwo}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
              <ExcelSheet data={this.state.general_report} name={"BalanceSheet report"}>
                    <ExcelColumn label="CODE" value="account_code"/>
                    <ExcelColumn label="NAME" value="account"/>
                    <ExcelColumn label="DEBITS" value="debit"/>
                    <ExcelColumn label="CREDITS" value="credit"/>
              </ExcelSheet>
            </ExcelFile>
            </>
            ) : null}
            </div>

          <Form layout="inline" className="balance-sheet-filter-form">
          <FormItem label="Date">
              <RangePicker onChange={
              (date, dateString) =>{
                this.setState({ dateone: dateString[0]});
                this.setState({ datetwo: dateString[1]});
              }
            } format={dateFormat} />

          </FormItem>

          <FormItem label="Show Opening Balances">
            <Switch
              checked={this.state.view_opening_balance}
              onChange={val=>{this.setState({view_opening_balance:val})}}
              checkedChildren="True"
              unCheckedChildren="False"
              />
          </FormItem>


          <ReportEmailControls
            emailReport={this.state.email_report}
            receivingEmail={this.state.receiving_email}
            onEmailReportChange={(val) => this.setState({ email_report: val })}
            onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
            companyEmail={this.state.companyprofile.company_email}
          />

          <FormItem>
                <Button
                 onClick={this.loadBalanceSheetReport}
                 type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
                </FormItem> 

          </Form>

            </div>

            <br></br>
            <h4 style={{justifyContent:'center',display:'flex',alignSelf:'center',color:'blue'}}>ASSETS</h4>

            {this.renderBalanceSheetSection(this.state.balancesheet_report_assets, 'assets')}
         
                    <reactstrp.Table bordered className="balance-sheet-equal-cols">
                       <thead>
                         <tr>
                           <th><h1 style={{color:'blue'}}>TOTAL ASSETS</h1></th>
                           {this.state.view_opening_balance?<th></th>:null}
                           <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={this.state.AllTotals.total_debits_asset} displayType={'text'} thousandSeparator={true}/></h1></th>
                           <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={this.state.AllTotals.total_credits_asset} displayType={'text'} thousandSeparator={true}/></h1></th>
         
                         </tr>
                       </thead>
                   </reactstrp.Table>
         
         
                   {/**
                    * 
                    * FINANCED BY EQUITY AND LIABILITIES
                    * 
                    * 
                    * 
                    * 
                    */}
         
         
                   <h4 style={{justifyContent:'center',display:'flex',alignSelf:'center',color:'blue'}}>FINANCED BY</h4>
                   <h5 style={{justifyContent:'center',display:'flex',alignSelf:'center'}}>Equity</h5>
                   {this.renderBalanceSheetSection(this.state.balancesheet_report_equity, 'equity')}
                  <reactstrp.Table bordered className="balance-sheet-equal-cols">
                       <thead>
                         <tr>
                           <th><h2 style={{color:'green'}}>TOTAL EQUITY</h2></th>
                                           {this.state.view_opening_balance?  <th></th>:null}
         
                           <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.state.AllTotals.total_debits_equity} displayType={'text'} thousandSeparator={true}/></h2></th>
                           <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.state.AllTotals.total_credits_equity} displayType={'text'} thousandSeparator={true}/></h2></th>
         
                         </tr>
                       </thead>
                   </reactstrp.Table>
         
                   <h5 style={{justifyContent:'center',display:'flex',alignSelf:'center'}}>Liability</h5>
                   {this.renderBalanceSheetSection(this.state.balancesheet_report_liability, 'liability')}
                  <reactstrp.Table bordered className="balance-sheet-equal-cols">
                       <thead>
                         <tr>
                           <th><h2 style={{color:'green'}}>TOTAL LIABILITY</h2></th>
                           {this.state.view_opening_balance? <th></th>:null}
                           <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.state.AllTotals.total_debits_liability} displayType={'text'} thousandSeparator={true}/></h2></th>
                           <th className="align-right"><h2 style={{color:'green',fontWeight:'bolder'}}><CurrencyFormat value={this.state.AllTotals.total_credits_liability} displayType={'text'} thousandSeparator={true}/></h2></th>
         
                         </tr>
                       </thead>
                   </reactstrp.Table>
                   <br></br>
         
         
                   <reactstrp.Table bordered className="balance-sheet-equal-cols">
                       <thead>
                         <tr>
                           <th><h1 style={{color:'blue'}}>TOTAL EQUITY & LIABILITY</h1></th>
                           {this.state.view_opening_balance?<th></th>:null}
                           <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={(this.state.AllTotals.total_debits_liability+this.state.AllTotals.total_debits_equity).toFixed(2)} displayType={'text'} thousandSeparator={true}/></h1></th>
                           <th className="align-right"><h1 style={{color:'blue',fontWeight:'bolder'}}><CurrencyFormat value={(this.state.AllTotals.total_credits_liability+this.state.AllTotals.total_credits_equity).toFixed(2)} displayType={'text'} thousandSeparator={true}/></h1></th>
         
                         </tr>
                       </thead>
                   </reactstrp.Table>

          </Panel>
          </Collapse>

          </div>

        </div>

    )

    }

  }
}

export default BalanceSheetDateRangeView; 
